import { render, staticRenderFns } from "./newsletterJS.vue?vue&type=template&id=43d31cee"
import script from "./newsletterJS.vue?vue&type=script&lang=js"
export * from "./newsletterJS.vue?vue&type=script&lang=js"
import style0 from "./newsletterJS.vue?vue&type=style&index=0&id=43d31cee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports